import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { StyledText } from '../../../styles/text';
import { fontSizes, spacing } from '../../../styles/theme';
export const StyledNoPromotionsContainer = styled.div `
  padding: ${spacing.xxlarge}px 0 110px 0;
  text-align: center;
  height: 450px;

  svg {
    max-width: 242px;
    max-height: 100%;
  }

  @media ${mediaQueries.lessThanMedium} {
    svg {
      max-width: 184px;
      max-height: 150px;
    }
  }
`;
export const StyledNoPromotionsMessage = styled(StyledText) `
  @media ${mediaQueries.lessThanMedium} {
    font-size: ${fontSizes.medium}px;
    padding: 0 10px;
  }
`;
//# sourceMappingURL=subcomponents.js.map